import React, { useState, useEffect } from 'react';

const Header = ({ onOpenModal }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/80 backdrop-blur-lg border-b border-white/10 py-3' : 'bg-transparent py-5'}`}>
      <nav className="container mx-auto px-6 flex items-center justify-between">
        <div className="flex items-center cursor-pointer group" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <span className="text-xl font-black tracking-tighter text-white uppercase transition-transform duration-300 group-hover:scale-105">
            BY DORI<span className="text-purple-500 italic">MENTOR</span>
          </span>
        </div>
        <button 
          onClick={onOpenModal}
          className="bg-white/10 hover:bg-purple-600 text-white px-6 py-2 rounded-full text-xs font-black uppercase tracking-widest transition-all border border-white/10 hover:border-purple-400"
        >
          Iscriviti
        </button>
      </nav>
    </header>
  );
};

export default Header;